import React, { useEffect, useRef, useState, useImperativeHandle } from 'react';
import { AddNode, ArrowDown, ArrowUp, ClearFilter, FilterIcon, SearchIcon, CancelRoles, SearchIconWhite } from '../../../assets/images';
import { Card, Dropdown, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap';
import RoleFeature from './RoleFeature';
import NestedList from './NestedList';
import Modal from "react-bootstrap/Modal";
import AlertTemplateMessage from '../AlertTemplate/AlertTemplateMessage';
import { createNewUserRole, getRoleNameList, GetUserRoleList, updateUserRole } from '../../../services/userManagementservice';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import { Checkbox, FormControlLabel } from '@mui/material';

const Roles = React.forwardRef((props, ref) => {
    let {
        roles,
        isDarkTheme,
        buttonDisable,
        isUserEdit,
        setIsUserEdit,
        role,
        onSaveUserRole,
        addNewClickedRole,
        setAddNewClickedRole,
        savebtnClick,
        validationError,
        setSavebtnClick,
        selectedRoleMaster,
        setSelectedRoleMaster,
        showWarningToast,
        moduleList,
        setmoduleList,
        setRoleList,
        mainRoleList,
        setMainRoleList,
        rolename,
        setRoleName,
        editDisable,
        setEditDisable,
        filteredRolesList,
        roleSelected,
        selectedRole,
        setSelectedRole,
        systemDefined,
    } = { ...props }
    const { handleSubmit, getValues, setValue, register, watch } = useForm({ ...role });

    const [displayModal, setDisplayModal] = useState(false);
    // const [roleList, setRoleList] = useState([]);
    // const [mainRoleList, setMainRoleList] = useState([]);
    const [roleSearch, setRoleSearch] = useState("");
    //const [moduleList, setmoduleList] = useState([]);    
    //const [rolename, setRoleName] = useState("");
    //const [selectedRole, setSelectedRole] = useState();
    const [isCheckEdit, setisCheckEdit] = useState(false);
    const [roleNameError, setRoleNameError] = useState('');
    // const [editDisable, setEditDisable] = useState(false); 
    const [cameraAccordionExpanded, setCameraAccordionExpanded] = useState(false);
    const [cameraOptions, setCameraOptions] = useState({
        live: true,
        playback: true,
        all: true,
        export: true
    });


    useEffect(() => {
        if (savebtnClick) {
            let templst = validationError.split(",");
            for (let i = 0; i < templst.length; i++) {
                if (templst[i].includes("name-")) {
                    setRoleNameError(templst[i].replace("name-", ""));
                    continue
                }
            }
            setSavebtnClick(false)
        }
    }, [savebtnClick]);


    useEffect(() => {
        setRoleList(roles);
        setMainRoleList(roles);
    }, [roles]);
    // const filteredRolesList = roleList.filter((item) => item.RoleName !== "Root User");



    // useEffect(() => {
    //     //debugger
    //     let arr = modules?.map((item) => {
    //         let obj = {
    //             ...item,
    //             ViewOperation: false,
    //             AddOperation: false,
    //             EditOperation: false,
    //             DeleteOperation: false
    //         }
    //         return obj;
    //     })        
    //     setmoduleList(arr);
    //     handleAddNewItem();
    // }, [modules]);


    useEffect(() => {
        if (addNewClickedRole) {
            clearInputFields();
        }
    }, [addNewClickedRole]);

    useEffect(() => {
        setSelectedRoleMaster(null)
    }, [])


    // useEffect(() => {
    //     getUserRoleList();
    // }, []);

    useImperativeHandle(ref, () => ({
        isDataChanged() {
            return getValues('RoleName') != role.RoleName ||
                getValues('AddOperation') != role.AddOperation ||
                getValues('EditOperation') != role.EditOperation ||
                getValues('DeleteOperation') != role.DeleteOperation ||
                getValues('ViewOperation') != role.ViewOperation
        }
    }))

    function isDataChanged() {
        return getValues('RoleName') != role.RoleName ||
            getValues('AddOperation') != role.AddOperation ||
            getValues('EditOperation') != role.EditOperation ||
            getValues('DeleteOperation') != role.DeleteOperation ||
            getValues('ViewOperation') != role.ViewOperation
    }

    const searchRoleList = (e) => {
        const query = e.target.value;
        setRoleSearch(query);
        if (query.trim() === "") {
            setRoleList(mainRoleList);
        } else {
            const filteredArray = filteredRolesList.filter(x => x.RoleName && x.RoleName.toLowerCase().includes(e.target.value.toLowerCase()));
            setRoleList(filteredArray);
        }
    }

    // const handleAddNewItem = () =>{
    //     let tempObj = {
    //         UserRoleID: 0
    //     }
    //     setIsUserEdit(true);  
    //     setRoleName("");
    //     setSelectedRole(tempObj);  
    //     let arr = modules?.map((item) => {
    //         if (item.MenuName == "Home Page"){
    //             return {
    //               ...item,
    //               AddOperation: true,
    //               DeleteOperation: true,
    //               EditOperation: true,
    //               ViewOperation: true,
    //             }
    //         }
    //         let obj = {
    //             ...item,
    //             ViewOperation: false,
    //             AddOperation: false,
    //             EditOperation: false,
    //             DeleteOperation: false
    //         }
    //         return obj;
    //     })        
    //     setmoduleList(arr);
    // }

    // const roleSelected = (item) =>{
    //    // debugger
    //     handleRoleClick(item.UserRoleID);
    //     setButtonDisable(false);
    //     if (item.UserRoleID == selectedRoleMaster?.UserRoleID) {
    //         return;
    //     }
    //     if (selectedRoleMaster != null && isUserEdit) {
    //         // Swal.fire({
    //         //   title: 'Operation in Progress.',
    //         //   text: "You have started the operation for a user role, do you want to discard any changes and continue to the other user role.",
    //         //   icon: 'warning',
    //         //   showCancelButton: true,
    //         //   confirmButtonColor: '#027aaa',
    //         //   cancelButtonColor: '#d33',
    //         //   confirmButtonText: 'Ok!',
    //         //   allowOutsideClick: false
    //         // }).then((result) => {
    //         //   if (result.isConfirmed) {
    //         //     getRoleNamebyId(item.UserRoleID);
    //         //     setRoleName(item.RoleName);
    //         //     checkSystemDefined(item.Issystemdefined)
    //         //   }
    //         // })
    //         getRoleNamebyId(item.UserRoleID);
    //         setRoleName(item.RoleName);
    //         checkSystemDefined(item.Issystemdefined);
    //       } 
    //       else {
    //         getRoleNamebyId(item.UserRoleID);
    //         setRoleName(item.RoleName)
    //         checkSystemDefined(item.Issystemdefined)
    //         setIsUserEdit(false);
    //         setIsEmptyForm(false);
    //       }
    // }

    const getDataFromResponse = (id, data) => {
        return data.find((i) => i.MenuID == id)
    }

    const getRoleNamebyId = (Id) => {
        try {
            getRoleNameList(Id).then((resp) => {
                if (resp.Status == "success") {
                    setSelectedRoleMaster(resp.Data)
                    setIsUserEdit(false);
                    let apiResponse = resp.Data[0].menu;
                    //console.log("Response---", apiResponse.length);
                    if (apiResponse == null) {
                        setmoduleList(moduleList)
                    }
                    else {
                        let temp = moduleList;
                        let arr = temp.map((item) => {
                            let data = getDataFromResponse(item.MenuId, apiResponse)
                            if (data) {
                                // if (data.Menuname == "Home Page"){
                                if (data.Menuname == "Dashboard") {
                                    return {
                                        ...item,
                                        AddOperation: true,
                                        DeleteOperation: true,
                                        EditOperation: true,
                                        ViewOperation: true,
                                        UserRoleMappingID: data.UserRoleMappingID
                                    }
                                }
                                return {
                                    ...item,
                                    AddOperation: data.AddOperation,
                                    DeleteOperation: data.DeleteOperation,
                                    EditOperation: data.EditOperation,
                                    ViewOperation: data.ViewOperation,
                                    UserRoleMappingID: data.UserRoleMappingID
                                }
                            } else {
                                return {
                                    ...item,
                                    AddOperation: false,
                                    DeleteOperation: false,
                                    EditOperation: false,
                                    ViewOperation: false,
                                }
                            }
                        })
                        setmoduleList(arr);
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    const checkSystemDefined = (item) => {
        if (item) {
            setEditDisable(true);
            showWarningToast("This is system defined role you can not update this role");

        } else {
            setEditDisable(false)
        }
    }



    function isDataChanged() {
        return getValues('rolename') != selectedRole.RoleName
    }

    const onCancel = (e) => {
        e.stopPropagation();
        if (isDataChanged()) {
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to cancel the changes made?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#027aaa',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setValue('RoleName', selectedRole.RoleName)
                    setValue('isAdd', moduleList.AddOperation)
                    setValue('isEdit', moduleList.EditOperation)
                    setValue('isDelete', moduleList.DeleteOperation)
                    setValue('isView', moduleList.ViewOperation);
                    setIsUserEdit(false)
                    clearInputFields();
                    setSelectedRole(null)
                }
            });
        }
        setIsUserEdit(true);
    }

    const clearInputFields = () => {
        setRoleName("");
        setAddNewClickedRole(false);
        setSelectedRoleMaster(null);
    }
    console.log("moduleList", moduleList)
    // useEffect(()=>console.log('Michael', moduleList, isUserEdit),[isUserEdit, moduleList])

    useEffect(() => {
        console.log("Module List Updated:", moduleList);
        if (moduleList?.length > 0 && moduleList?.find((item) => item.MenuName === "Cameras" && item?.MenuFunctions?.length > 0)) {
            let cameraFunctions = moduleList.find((item) => item.MenuName === "Cameras").MenuFunctions;
            let obj = {
                live: cameraFunctions.find((i) => i.FunctionName === "Live")?.IsAllowed || false,
                playback: cameraFunctions.find((i) => i.FunctionName === "Playback")?.IsAllowed || false,
                export: cameraFunctions.find((i) => i.FunctionName === "Export")?.IsAllowed || false,
            }
            setCameraOptions(obj);
        } else {
            let temp_obj = {
                live: true,
                playback: true,
                all: true,
                export: true
            }
            setCameraOptions(temp_obj);
        }
    }, [moduleList])

    const handleCheckboxChange = (moduleId, property) => {
        // debugger
        const updatedModules = moduleList.map((item) => {
            if (item.MenuId === moduleId) {
                return { ...item, [property]: !item[property] };
            }
            return item;
        });



        const homeModule = moduleList.find((item) => item.MenuId === 2);
        //setEditDisable(homeModule);
        setmoduleList(updatedModules);
        //   if (!isUserEdit) {
        //     setIsUserEdit(true);
        // }
        // if (!isUserEdit) {
        //     setTimeout(() => {
        //         setIsUserEdit(true);
        //     }, 100);
        // }
    };

    const toggleSelectAll = (property) => {
        const allSelected = moduleList.every(item => item[property]);
        // setmoduleList(moduleList.map(item => ({ ...item, [property]: !allSelected })));

        setmoduleList(
            moduleList.map(item =>
                item.MenuName === "Home Page" || item.MenuName === "Segmented Dashboard" || item.MenuName === "Consolidated Dashboard" || item.MenuName === "Dashboard"
                    ? item // Skip updating "Home page"
                    : { ...item, [property]: !allSelected } // Toggle other items
            )
        );


    };

    const addRole = (e) => {
        let tempValue = e.target.value.replace(/[-’/`~!#*$@_%+=.,^&\d(){}[\]|;:”<>?\\]/gi, "");
        if (!/[0-9a-zA-Z]/.test(e.key)) {
            e.preventDefault();
        } else {
            setValue("RoleName", tempValue);
        }
    }

    const clearRoleFields = () => {
        setRoleNameError('');
    }

    const handleRoleClick = (id) => {
        // debugger
        const obj = filteredRolesList.find((item) => item.UserRoleID === id);
        setSelectedRole(obj);
    };

    // const onSaveUserRole = async (data, item, moduleData) =>{
    //    // debugger
    //       let moduleArr =  moduleData.map((item) => {
    //           let obj = {
    //               id: item.MenuId,
    //               add: item.AddOperation,
    //               edit: item.EditOperation,
    //               delete: item.DeleteOperation,
    //               view: item.ViewOperation
    //           }
    //           return obj;
    //       })

    //       let RoleName = data.RoleName;
    //       let exRolename =  item.RoleName;
    //       let validationError = "";

    //       if(!RoleName && !exRolename){
    //       // if(!exRolename){
    //         validationError += "name-Please enter role name!,"
    //        //}
    //       }
    //       else if(RoleName === "" && exRolename){
    //         validationError += "name-Please enter role name!," 
    //       }

    //       setInputValidationError(validationError);
    //       setSavebtnClick(true)
    //       setButtonDisable(true);
    //       if (validationError != "") {
    //           return;
    //       }      
    //       if(item.UserRoleID == 0){
    //           try {
    //               let roleObj = {
    //                   'roleName': data.RoleName ,
    //                   "userId": localStorage.getItem('UserID'),
    //                   "organizationMasterId": (localStorage.getItem('user')=='null')?0: JSON.parse(localStorage.getItem('user')).OrganizationMasterID,
    //                   "menuData" : moduleArr,    
    //               }
    //               let res = await createNewUserRole(roleObj);            
    //               if (res.Status == "success" || res.status == "Ok") {
    //                   showSuccessToast(res.Message || res.message);
    //                   setButtonDisable(false);
    //                   setIsUserEdit(false)
    //                   getUserRoleList();
    //                  // handleRoleClick(res.Data.UserRoleID);
    //                   //setSelectedRole(roleObj);
    //                   let temp = {
    //                     "RoleName" : RoleName,
    //                     "UserRoleID": res.Data.UserRoleID
    //                   }
    //                   setSelectedRole(temp);
    //               }
    //               else{
    //                   showErrorToast(res.Message || res.message);
    //               }

    //           } catch (error) {
    //               showErrorToast(error)
    //           }
    //       }
    //       else{
    //           /*------Update user roles------- */
    //           try {     
    //               let listArr =  moduleData.map((item) => {
    //                   let obj = {
    //                       id: item.MenuId,
    //                       mappingId: item.UserRoleMappingID, 
    //                       add: item.AddOperation,
    //                       edit: item.EditOperation,
    //                       delete: item.DeleteOperation,
    //                       view: item.ViewOperation,
    //                   }
    //                   return obj;
    //               })
    //               let UpdateObj = {
    //                   "roleName": data.RoleName || item.RoleName,
    //                   "userRoleId": item.UserRoleID,
    //                   "userId": localStorage.getItem('UserID'),
    //                   "organizationMasterId": (localStorage.getItem('user')=='null')?0: JSON.parse(localStorage.getItem('user')).OrganizationMasterID,
    //                   "menuData": listArr,
    //               }

    //               let res = await updateUserRole(UpdateObj);            
    //               if (res.Status == "success" || res.status == "Ok") {
    //                   showSuccessToast(res.Message || res.message);
    //                   setButtonDisable(false);
    //                   setIsUserEdit(false)
    //                   getUserRoleList();
    //                   //setSelectedRole(UpdateObj);
    //                   handleRoleClick(UpdateObj.userRoleId);
    //               }
    //               else{
    //                   showErrorToast(res.Message || res.message);
    //                   setIsUserEdit(true)
    //                   setButtonDisable(true);
    //               }
    //           } catch (error) {
    //               showErrorToast(error)
    //           }
    //       }

    // }


    const handleCameraOptionChange = (option) => {
        setCameraOptions(prev => ({
            ...prev,
            [option]: !prev[option],
        }));
    };

    return (
        <>
            <div className='SiteMainContainer'>
                <div className='SiteLeftContainer'>
                    <div className="m-2 HeaderSiteList">
                        <input
                            id="Search_txt_site"
                            className="SearchViewInput1"
                            type="text"
                            placeholder="Search User Role"
                            value={roleSearch}
                            onChange={(e) => searchRoleList(e)}
                        />
                        <div className="SearchTextDivConfigTool">
                            {
                                isDarkTheme ?
                                    <img
                                        className="EyeIcon"
                                        src={SearchIcon}
                                        alt="search icon"
                                    /> :
                                    <img
                                        className="EyeIcon"
                                        src={SearchIconWhite}
                                        alt="search icon" height="15"
                                    />
                            }
                        </div>
                    </div>

                    <div className='UserLeftList'>
                        {
                            filteredRolesList && (
                                filteredRolesList?.length > 0 ?
                                    filteredRolesList.map(item => {
                                        return <div
                                            className={
                                                selectedRole?.UserRoleID == item.UserRoleID
                                                    ? "OneList SelectedList"
                                                    : "OneList"
                                            }
                                            key={item.UserRoleID}
                                            onClick={(e) => {
                                                // getRoleNamebyId(item.UserRoleID)
                                                //handleRoleClick(item.UserRoleID)
                                                //setRoleName(item.RoleName)
                                                e.stopPropagation();
                                                roleSelected(item)
                                                clearRoleFields()
                                            }}>
                                            <p className="ListofText">{item.RoleName}</p>
                                        </div>
                                    }) : <div className="no-data-found"><p>No Roles Found</p></div>
                            )
                        }
                        {
                            !filteredRolesList && (
                                <div className="no-data-found">No Roles Available</div>
                            )
                        }
                    </div>
                </div>

                <div className='SiteRightContainer p-3'>
                    {
                        selectedRoleMaster == null
                            ?
                            <div style={{ padding: "20px" }}>
                                <AlertTemplateMessage message={"Select a role to update user roles or add new role"} />
                            </div>
                            :
                            <>
                                <div className="inputMainContainer w40dot75rem">
                                    <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Role Name</label>
                                        <input
                                            //{...register("RoleName")}
                                            className="inputType"
                                            placeholder={isUserEdit ? 'Ex. Role_Name_One_Here' : 'Ex. Role_Name_One_Here'}
                                            value={rolename}
                                            {...register("RoleName")}
                                            //defaultValue={selectedRoleMaster.roleName}
                                            disabled={!isUserEdit}
                                            onChange={(e) => {
                                                setRoleName(e.target.value);
                                                setRoleNameError("")
                                                addRole(e)
                                            }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{roleNameError}</span></p>
                                    </div>
                                </div>

                                <div style={{ width: "100%", float: "left" }}>
                                    <Tabs
                                        defaultActiveKey="Module"
                                        id="uncontrolled-tab-example"
                                        className="AlertTemplateTab"
                                    >
                                        <Tab eventKey="Module" title="Module Access">
                                            <div>
                                                {/* Adding table for module name and toggle checkboxes */}
                                                {/* <RolesCheckedTable
                                     moduleList={moduleList}
                                     selectedRoleMaster={selectedRoleMaster} 
                                     setSelectedRoleMaster={setSelectedRoleMaster}
                                     getRoleNamebyId={getRoleNamebyId}/> */}

                                                {/* Static table */}
                                                <div>
                                                    <div className='ModuleTabHeader'>
                                                        <div className='ModuleHeaderStyle'>
                                                            <p className='ModuleNameTitle'>Module Name</p>
                                                            <div className='ModuleHeaderButton'>
                                                                <div>
                                                                    <p>View</p>
                                                                    <div className='togglecheckbox'>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled={!isUserEdit}
                                                                                onChange={() => toggleSelectAll('ViewOperation')}
                                                                                checked={
                                                                                    moduleList
                                                                                        ?.filter(item => item.MenuName !== "Home Page" || item.MenuName !== "Dashboard" || item.MenuName !== "Consolidated Dashboard" || item.MenuName !== "Segmented Dashboard")
                                                                                        .every(item => item.ViewOperation)
                                                                                }
                                                                            />
                                                                            <span />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'none' }}>
                                                                    <p>Add</p>
                                                                    <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled={!isUserEdit}
                                                                                onChange={() => toggleSelectAll('AddOperation')}
                                                                                //checked={moduleList.every(item => item.AddOperation)}
                                                                                checked={
                                                                                    moduleList
                                                                                        ?.filter(item => item.MenuName !== "Home Page" || item.MenuName !== "Dashboard" || item.MenuName !== "Consolidated Dashboard" || item.MenuName !== "Segmented Dashboard")
                                                                                        .every(item => item.AddOperation)
                                                                                }
                                                                            />
                                                                            <span />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'none' }}>
                                                                    <p>Edit</p>
                                                                    <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled={!isUserEdit}
                                                                                onChange={() => toggleSelectAll('EditOperation')}
                                                                                // checked={moduleList.every(item => item.EditOperation)}
                                                                                checked={
                                                                                    moduleList
                                                                                        ?.filter(item => item.MenuName !== "Home Page" || item.MenuName !== "Dashboard" || item.MenuName !== "Consolidated Dashboard" || item.MenuName !== "Segmented Dashboard")
                                                                                        .every(item => item.EditOperation)
                                                                                }
                                                                            />
                                                                            <span />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div style={{ textAlign: "center", display: 'none' }}>
                                                                    <p>Delete</p>
                                                                    <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                disabled={!isUserEdit}
                                                                                onChange={() => toggleSelectAll('DeleteOperation')}
                                                                                // checked={moduleList.every(item => item.DeleteOperation)}
                                                                                checked={
                                                                                    moduleList
                                                                                        ?.filter(item => item.MenuName !== "Home Page" || item.MenuName !== "Dashboard" || item.MenuName !== "Consolidated Dashboard" || item.MenuName !== "Segmented Dashboard")
                                                                                        .every(item => item.DeleteOperation)
                                                                                }
                                                                            />
                                                                            <span />
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                {/* {
                                                    availableRoles.map((role, index) => (
                                                    <>
                                                    <div key={index}>
                                                        <p> {role.name}</p>
                                                        <div className='togglecheckbox'>
                                                            <label>
                                                                <input
                                                                    type="checkbox"
                                                                    //disabled={!isUserEdit}
                                                                    id={role.id}
                                                                    //checked={role.isCheck}
                                                                    disabled={!isUserEdit || role.isDisable}
                                                                    checked={role.isCheck}
                                                                    //onChange={() => handleCheckboxChange(role.id)}
                                                                />
                                                                <span />
                                                            </label>
                                                        </div>                                                        
                                                    </div>
                                                    </>
                                                ))
                                                } */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='ModuleScrollDiv'>
                                                        <ul>
                                                            {
                                                                moduleList && (
                                                                    moduleList?.length > 0 ?
                                                                        moduleList.filter((i) => i.MenuName !== "Home Page" && i.MenuName !== "Dashboard").map(item => {
                                                                            return <li className='ModuleMainList' key={item.MenuId}>
                                                                                <div className='ModuleListOptions'>
                                                                                    <p className='ModuleNameTitle'>{item.MenuName || item.Menuname}</p>

                                                                                    <div className='ModuleHeaderButton'>
                                                                                        <div className='togglecheckbox'>
                                                                                            {!isCheckEdit ?
                                                                                                <label>
                                                                                                    <input
                                                                                                        name="ViewOperation"
                                                                                                        type="checkbox"
                                                                                                        {...register("ViewOperation")}
                                                                                                        disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                        checked={item.ViewOperation}
                                                                                                        onChange={() => handleCheckboxChange(item.MenuId, 'ViewOperation')}
                                                                                                    />
                                                                                                    <span />
                                                                                                </label>
                                                                                                :
                                                                                                <button className='RolesCancelBtn'>
                                                                                                    <img src="CancelRoles" alt="Cancel" />
                                                                                                </button>
                                                                                            }
                                                                                        </div>


                                                                                        {/* Hidden other checkboxes */}
                                                                                        <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                                            <label>
                                                                                                <input
                                                                                                    name="AddOperation"
                                                                                                    type="checkbox"
                                                                                                    {...register("AddOperation")}
                                                                                                    disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                    checked={item.AddOperation}
                                                                                                    onChange={() => handleCheckboxChange(item.MenuId, 'AddOperation')}
                                                                                                />
                                                                                                <span />
                                                                                            </label>
                                                                                        </div>

                                                                                        <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                                            <label>
                                                                                                <input
                                                                                                    name="EditOperation"
                                                                                                    type="checkbox"
                                                                                                    {...register("EditOperation")}
                                                                                                    disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                    checked={item.EditOperation}
                                                                                                    onChange={() => handleCheckboxChange(item.MenuId, 'EditOperation')}
                                                                                                />
                                                                                                <span />
                                                                                            </label>
                                                                                        </div>

                                                                                        <div className='togglecheckbox' style={{ display: 'none' }}>
                                                                                            <label>
                                                                                                <input
                                                                                                    name="DeleteOperation"
                                                                                                    type="checkbox"
                                                                                                    {...register("DeleteOperation")}
                                                                                                    disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                    checked={item.DeleteOperation}
                                                                                                    onChange={() => handleCheckboxChange(item.MenuId, 'DeleteOperation')}
                                                                                                />
                                                                                                <span />
                                                                                            </label>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                                {/* Show camera options directly under when ViewOperation is toggled */}
                                                                                {item.MenuName === "Cameras" && item.ViewOperation && (
                                                                                    <div className='ModuleListOptions'>
                                                                                        <Typography variant="subtitle2">Camera Options:</Typography>
                                                                                        <div className='ModuleHeaderButton'>
                                                                                            {/* <FormControlLabel
                                                                        className='fontSizeOptions'
                                                                        control={
                                                                        <Checkbox
                                                                            checked={cameraOptions.snapshot}
                                                                            onChange={() => handleCameraOptionChange('Snapshot')}
                                                                        />
                                                                        }
                                                                        label="Snapshot"
                                                                    />

                                                                    <FormControlLabel
                                                                        className='fontSizeOptions'
                                                                        control={
                                                                        <Checkbox
                                                                            checked={cameraOptions.fullScreen}
                                                                            onChange={() => handleCameraOptionChange('FullScreen')}
                                                                        />
                                                                        }
                                                                        label="Full Screen"
                                                                    /> */}

                                                                                            <FormControlLabel
                                                                                                className='fontSizeOptions'
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={cameraOptions.playback}
                                                                                                        disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                        onChange={() => handleCameraOptionChange('playback')}
                                                                                                    />
                                                                                                }
                                                                                                label="Playback"
                                                                                            />

                                                                                            <FormControlLabel
                                                                                                className='fontSizeOptions'
                                                                                                control={
                                                                                                    <Checkbox
                                                                                                        checked={cameraOptions.export}
                                                                                                        disabled={["Dashboard", "DashBoard", "Consolidated Dashboard", "Segmented Dashboard"].includes(item.MenuName) || !isUserEdit}
                                                                                                        onChange={() => handleCameraOptionChange('export')}
                                                                                                    />
                                                                                                }
                                                                                                label="Video Export"
                                                                                            />

                                                                                            {/* <FormControlLabel
                                                                        className='fontSizeOptions'
                                                                        control={
                                                                        <Checkbox
                                                                            checked={cameraOptions.alertCreation}
                                                                            onChange={() => handleCameraOptionChange('alertCreation')}
                                                                        />
                                                                        }
                                                                        label="Alert Creation"
                                                                    /> */}
                                                                                        </div>
                                                                                    </div>

                                                                                )}
                                                                            </li>
                                                                        }) : <div className="no-data-found"><p>No Modules Found</p></div>
                                                                )
                                                            }

                                                            {/* <NestedList/>   */}
                                                            {/* This is nested list hide by Rupali */}
                                                        </ul>
                                                    </div>
                                                </div>

                                                <div style={{ textAlign: "center", marginTop: "15px" }}>
                                                    {
                                                        // selectedRole?.UserRoleID != 0 && !isUserEdit &&
                                                        // <button type="submit" className="DataAccessEdit" style={{ width: "100px" }} 
                                                        //     onClick={() => {
                                                        //         //onNavigate('User Roles');
                                                        //         //setIsItemClick(false);
                                                        //         //setSelectedSubMenu('User Roles');
                                                        //         //setAddNewClickedRole(true)
                                                        //         setIsEmptyForm(true)
                                                        //         setIsUserEdit(true)
                                                        //         handleAddNewItem()
                                                        //     }}
                                                        // >
                                                        //     <span className="ViewUpdate">Add New</span>
                                                        // </button>
                                                        systemDefined ?
                                                            <p className='SystemDefineText m-0 text-left'>This is system defined role you can not update this role</p>
                                                            : null
                                                    }
                                                    {selectedRole?.UserRoleID === 0 && (
                                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                                            onClick={handleSubmit((e) => onSaveUserRole(e, selectedRole, moduleList, cameraOptions))}>
                                                            <span className="ViewUpdate">Save</span>
                                                        </button>
                                                    )}
                                                    {/* {console.log('Michael1', selectedRole?.UserRoleID, isUserEdit, editDisable)} */}

                                                    {selectedRole?.UserRoleID !== 0 && !isUserEdit && !editDisable && (
                                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                                            onClick={() => setIsUserEdit(true)}>
                                                            <span className="ViewUpdate">Edit</span>
                                                        </button>
                                                    )}

                                                    {selectedRole?.UserRoleID !== 0 && isUserEdit && (
                                                        <>
                                                            <button className="DataAccessEdit" style={{ width: "100px" }}
                                                                disabled={buttonDisable}
                                                                onClick={handleSubmit((e) => onSaveUserRole(e, selectedRole, moduleList, cameraOptions))}>
                                                                <span className="ViewUpdate">Update</span>
                                                            </button>
                                                            <button className="DataAccessEdit" style={{ width: "100px" }}
                                                                onClick={(e) => onCancel(e)}>
                                                                <span className="ViewUpdate">Cancel</span>
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </Tab>

                                        {
                                            false ?
                                                <Tab eventKey="Feature" title="Feature Access">
                                                    <div>
                                                        <div className='featureTabDiv'>
                                                            <RoleFeature />
                                                            <div className='featureTabDetailsView'>
                                                                <div className='ModuleTabHeader'>
                                                                    <div className='ModuleHeaderStyle' style={{ marginTop: "15px" }}>
                                                                        <p>Alert Features</p>
                                                                    </div>
                                                                </div>
                                                                <div className='ModuleScrollDiv'>
                                                                    <ul>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>View Alert</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>Process Alert</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>View Pre-post</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>Live Alert</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>

                                                                    </ul>
                                                                </div>
                                                            </div>
                                                            <div className='featureTabDetailsView'>
                                                                <div className='ModuleTabHeader'>
                                                                    <div className='ModuleHeaderStyle' style={{ marginTop: "15px" }}>
                                                                        <p>Reports</p>
                                                                    </div>
                                                                </div>
                                                                <div className='ModuleScrollDiv'>
                                                                    <ul>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>View Alert</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        <li className='ModuleMainList'>
                                                                            <div className='ModuleListOptions'>
                                                                                <p>Download Reports</p>
                                                                                <div className='togglecheckbox'>
                                                                                    <label>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                        />
                                                                                        <span />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div style={{ textAlign: "center", marginTop: "15px" }}>
                                                            <button type="submit" className="DataAccessEdit" style={{ width: "100px" }} >
                                                                <span className="ViewUpdate">Save</span>
                                                            </button>
                                                            <button className="DataAccessEdit" style={{ width: "100px" }}>
                                                                <span className="ViewUpdate">Edit</span>
                                                            </button>
                                                            <button className="DataAccessEdit" style={{ width: "100px" }} >
                                                                <span className="ViewUpdate">Cancel</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Tab> : null
                                        }
                                        {
                                            false ?
                                                <Tab eventKey="User" title="User Assignment">
                                                    <div>
                                                        <div className='UserTabHeader'>
                                                            <div className="HeaderSiteList" style={{ height: "35px" }}>
                                                                <input
                                                                    id="Search_txt_site"
                                                                    className="SearchViewInput1"
                                                                    style={{ width: "84%" }}
                                                                    type="text"
                                                                    placeholder="Search users"
                                                                />
                                                                <div className="SearchTextDivConfigTool">
                                                                    <img
                                                                        className="EyeIcon"
                                                                        src={SearchIcon}
                                                                        alt="search icon"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='d-flex'>
                                                                <button className="DataAccessEdit" style={{ width: "200px" }} onClick={() => {
                                                                    setDisplayModal(true)
                                                                }}>
                                                                    <img src={AddNode} alt='add new form' />
                                                                    <span className="ViewUpdate ml-2">Add Users to Role</span>
                                                                </button>
                                                                {/* <div className="SavedFilterDiv">
                                            <Dropdown>
                                                <Dropdown.Toggle variant="light">Drop value</Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                <>
                                                <p>User one</p>
                                                </>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            </div>
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={<Tooltip>Apply Filter</Tooltip>}
                                                >
                                                <button className= "IconsButtonDiv">
                                                    <img
                                                    src={FilterIcon}
                                                    className="camera-icon-height"
                                                    alt="filter icon"
                                                    />
                                                </button>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                            placement="bottom"
                                            overlay={<Tooltip>Clear Filter</Tooltip>}
                                            >
                                            <button className="IconsButtonDiv">
                                                <img
                                                src={ClearFilter}
                                                className="camera-icon-height"
                                                alt="Clear filter icon"
                                                />
                                            </button>
                                            </OverlayTrigger> */}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <table className="table table-fixed EventReportTable m-0"
                                                                style={{ width: "100%" }}
                                                                id="event-activity-report">
                                                                <thead className="ReportTableHeader ReportTableHeadReport">
                                                                    <tr>
                                                                        <th>
                                                                            Name
                                                                        </th>
                                                                        <th>
                                                                            Username
                                                                        </th>

                                                                        <th>
                                                                            Email ID
                                                                        </th>

                                                                        <th>
                                                                            Contact Number
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody style={{ height: "calc(100vh - 460px)" }}>
                                                                    <tr>
                                                                        <>
                                                                            <td>
                                                                                User Name One
                                                                            </td>
                                                                            <td>
                                                                                User Name One
                                                                            </td>
                                                                            <td>
                                                                                emailed1234@email.com
                                                                            </td>
                                                                            <td>
                                                                                +91 9898989898
                                                                            </td>
                                                                            {/* <td>
                                                        <div className='togglecheckbox'>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                            />
                                                            <span />
                                                        </label>
                                                    </div> 
                                                        </td> */}
                                                                        </>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                                                <button type="submit" className="DataAccessEdit" style={{ width: "100px" }} >
                                                                    <span className="ViewUpdate">Save</span>
                                                                </button>
                                                                <button className="DataAccessEdit" style={{ width: "100px" }}>
                                                                    <span className="ViewUpdate">Edit</span>
                                                                </button>
                                                                <button className="DataAccessEdit" style={{ width: "100px" }} >
                                                                    <span className="ViewUpdate">Cancel</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab> : null
                                        }
                                    </Tabs>
                                </div>
                            </>

                    }

                </div>
            </div>

            <Modal
                size='xl'
                show={displayModal}
                onHide={() => setDisplayModal(false)}
                // className='downloadUtilityMainclass'
                backdrop="static"
            >
                <Modal.Header closeButton > Add Users to This Role
                </Modal.Header>
                <Modal.Body>
                    <div className='ModalBodyDiv'>
                        <div>
                            <table className="table table-fixed EventReportTable m-0"
                                style={{ width: "100%" }}
                                id="event-activity-report">
                                <thead className="ReportTableHeader ReportTableHeadReport">
                                    <tr>
                                        <th>
                                            <input type='checkbox' />
                                        </th>
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Username
                                        </th>
                                        <th>
                                            Current Role
                                        </th>
                                        <th>
                                            Email ID
                                        </th>

                                        <th>
                                            Contact Number
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ height: "calc(100vh - 490px)" }}>
                                    <tr>
                                        <>
                                            <td>
                                                {/* <div className='togglecheckbox'> */}
                                                <input
                                                    type="checkbox"
                                                />
                                                <span />
                                                {/* </div>  */}
                                            </td>
                                            <td>
                                                User Name One
                                            </td>
                                            <td>
                                                User Name One
                                            </td>
                                            <td>
                                                User Name One
                                            </td>
                                            <td>
                                                emailed1234@email.com
                                            </td>
                                            <td>
                                                +91 9898989898
                                            </td>
                                            {/* <td>
                                                <div className='togglecheckbox'>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                    />
                                                    <span />
                                                </label>
                                            </div> 
                                                </td> */}
                                        </>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                <button type="submit" className="DataAccessEdit" style={{ width: "150px" }} >
                                    <span className="ViewUpdate">Add Selected Users</span>
                                </button>
                                <button className="DataAccessEdit" style={{ width: "200px" }}>
                                    <span className="ViewUpdate">Add Selected Users and Close</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
});

export default Roles

